import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Info } from 'lib/styles';
import Accordion from 'components/Accordion';
import Color from './Color';
import ContentType from './ContentType';
import Space from './Space';
import Layout from './Layout';
import BuildingPattern from './BuildingPattern';
import Logo from './Logo';

import layoutConfig from '../../../layoutConfig';

const Container = styled.div`
	padding: 16px 40px;
`;

const RemovePage = styled.button`
	width: calc(100% - 16px);
	padding: 16px;
	text-align: center;
	appearance: none;
	background: #D0021B;
	border: 2px solid white;
	border-radius: 8px;
	color: white;
	transition: opacity 0.3s ease-out;
	cursor: pointer;
	margin: 4px 8px;

	&:hover {

	}
`;

const Page = props => {
	const { t, pageData: { layout, options } } = props;
	const layoutOptions = layout in layoutConfig ? layoutConfig[layout].options : [];

	return (
		<Container>
			{
				layoutOptions.length > 0 &&
				<Layout
				  layoutOptions={layoutOptions}
				  layout={options.layout}
				  updatePageSettingsHandler={props.updateSettingsHandler}
				/>
			}

			<Color
				color={props.data['background-color']}
				updatePageSettingsHandler={props.updateSettingsHandler}
			/>

			<Space
				spaces={props.building.spaces}
				space={props.data.space}
				updatePageSettingsHandler={props.updateSettingsHandler}
			/>

			<BuildingPattern
				buildingPattern={props.data.buildingPattern}
				updatePageSettingsHandler={props.updateSettingsHandler}
			/>

			<Logo
				logo={props.data.logo}
				updatePageSettingsHandler={props.updateSettingsHandler}
			/>

			<ContentType />

			<Info
				icon="light-bulb"
				fill="orange"
				info={t('brochure/Controls/Page/slot type')}
			/>

			<Accordion label={t('controls/page/remove page')}>
				<RemovePage onClick={() => {
					if (window.confirm(t('controls/page/remove confirm'))) {
						props.removePageDataHandler(props.pageId);
					}
				}}>{t('controls/page/remove page')}</RemovePage>
			</Accordion>

		</Container>
	)
}

Page.propTypes = {
	t: PropTypes.func,
	pageId: PropTypes.string,
	data: PropTypes.object,
	pageData: PropTypes.object,
	building: PropTypes.object,
	updateSettingsHandler: PropTypes.func,
	removePageDataHandler: PropTypes.func,
}

export default translate('translations')(Page)
